import React, { useState } from "react";
import "./faq.m.css";
import { FaqItem } from "../faq-item";
import { useSelector } from "react-redux";
import get from "lodash/get";

/*const faqData = [
  {
    id: 1,
    title: "How can I manage my subscription?",
    content:
      "You can manage your subscription by logging into your account on our website. From there, you can update your payment information, change your subscription plan, or cancel your subscription if needed.",
  },
  {
    id: 2,
    title: "Can I share my subscription with others?",
    content:
      "You can manage your subscription by logging into your account on our website. From there, you can update your payment information, change your subscription plan, or cancel your subscription if needed.",
  },
  {
    id: 3,
    title: "What should I do if I forgot my password?",
    content:
      "You can manage your subscription by logging into your account on our website. From there, you can update your payment information, change your subscription plan, or cancel your subscription if needed.",
  },
  {
    id: 4,
    title: "How do I cancel my subscription?",
    content:
      "You can manage your subscription by logging into your account on our website. From there, you can update your payment information, change your subscription plan, or cancel your subscription if needed.",
  },
  {
    id: 5,
    title: "How can I manage my subscription 2?",
    content:
      "You can manage your subscription by logging into your account on our website. From there, you can update your payment information, change your subscription plan, or cancel your subscription if needed.",
  },
  {
    id: 6,
    title: "How can I manage my subscription 3?",
    content:
      "You can manage your subscription by logging into your account on our website. From there, you can update your payment information, change your subscription plan, or cancel your subscription if needed.",
  },
  {
    id: 7,
    title: "How can I manage my subscription 4?",
    content:
      "You can manage your subscription by logging into your account on our website. From there, you can update your payment information, change your subscription plan, or cancel your subscription if needed.",
  },
  {
    id: 8,
    title: "How can I manage my subscription 5?",
    content:
      "You can manage your subscription by logging into your account on our website. From there, you can update your payment information, change your subscription plan, or cancel your subscription if needed.",
  },
];*/

export const FaqSection = () => {
  const [expandedId, setExpandedId] = useState(1);
  const [showMore, setShowMore] = useState(false);
  const qtConfig = useSelector((state) => get(state, ["qt", "config"]));
  const faqData = get(qtConfig, ["faq", "faq_data"], []);
  const handleToggle = (id) => {
    setExpandedId(expandedId === id ? null : id);
  };

  const visibleFaqs = showMore ? faqData : faqData.slice(0, 4);

  return (
    <section styleName="faq-section" aria-label="Frequently Asked Questions">
      <div styleName="faq-content">
        <div styleName="faq-items">
          <div styleName="faq-title">
            <h1 styleName="faq-heading">Frequently Asked Questions</h1>
            {visibleFaqs.map((faq) => (
              <FaqItem
                key={faq.id}
                id={faq.id}
                title={faq.title}
                content={faq.content}
                isExpanded={expandedId === faq.id}
                setExpandedId={setExpandedId}
                onToggle={() => handleToggle(faq.id)}
              />
            ))}
          </div>
          <button styleName="view-more-button" onClick={() => setShowMore(!showMore)} aria-expanded={showMore}>
            <span styleName="view-more-background">{showMore ? "View Less" : "View More"}</span>
          </button>
        </div>
      </div>
    </section>
  );
};
